(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('GpfsBatchInvoiceDetailController', GpfsBatchInvoiceDetailController);

    GpfsBatchInvoiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GpfsBatchInvoice', 'GpfsBatch', 'Invoice'];

    function GpfsBatchInvoiceDetailController($scope, $rootScope, $stateParams, previousState, entity, GpfsBatchInvoice, GpfsBatch, Invoice) {
        var vm = this;

        vm.gpfsBatchInvoice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ccsTrApp:gpfsBatchInvoiceUpdate', function(event, result) {
            vm.gpfsBatchInvoice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
